// You can customize the template with the help of this file

import logo from '@src/assets/images/logo/tenxlogo.png'

//Template config options
const themeConfig = {
  app: {
    appName: 'Hire10x',
    appLogoImage: logo,
  },
  layout: {
    isRTL: false,
    skin: 'semi-dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white', // BS color options [primary, success, etc]
      primaryColor: 'primary',
      secondaryColor: 'success',
    },
    footer: {
      type: 'hidden', // static, sticky, hidden
    },
    customizer: true, //TODO: remove spinner
    scrollTop: true, // Enable scroll to top button
  },
}

export default themeConfig
